import { Button } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface DashboardButtonProps {
  onClick: () => void;
  fadeDelay?: number;
}

export const DashboardButton: React.FC<DashboardButtonProps> = ({ onClick, fadeDelay = 0 }) => {
  const { t } = useTranslation();

  const fadeInAnimation = {
    '@keyframes fadeIn': {
      from: {
        opacity: 0,
        transform: 'translateY(10px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
    animation: `fadeIn 0.5s ease-out ${fadeDelay}s both`,
  };

  return (
    <Button
      colorPalette="gray"
      h={12}
      onClick={onClick}
      css={fadeDelay > 0 ? fadeInAnimation : undefined}
    >
      {t('welcome.goToDashboard')}
    </Button>
  );
};
